module.exports = function(product, options) {
  if(product.properties._availabilityFulfilment == 'Digital' && product.properties._availabilityProductLifecycle == 'PreOrder') {
    return options.inverse(this);
  }
  return options.fn(this);
};